import React from 'react';
import './Style.css';

export default function About(props) {
    React.useEffect(() => document.title = 'About Barpazir');
    return (
        <div className="about">
            <div className="main">
                <div className="english">
                    <h2 className="title">What is "Barpazir"?</h2>
                    <br />
                    Barpazir is the latest solution developed by ECF. This solution provides the cargo companies with possibility of finding cargo on the return leg of their international transit fleet.<br />
                    By using "Barpazir", anyone who intends to ship their cargo to Iran, can easily find active trucks near their intended locations.<br />
                    When choosing each of the available trucks on the map, the cargo company's contact information will be displayed to submit a shipping request.
                </div>
                <img className="diagram" src="/Images/AboutUs/Diagram.png" alt="Diagram" title="Diagram" />
                <div className="farsi">
                    <h2 className="title">بارپذیر چیست؟</h2>
                    <br />
                    سامانه “بارپذیر" راهکار جدیدی از شرکت ”ارتباطات کنترل فراگستر” است. این سامانه امکان تامین بار در مسیر بازگشت ناوگان ترانزیتی شرکت‌های حمل و نقل را تسهیل می‌نماید.<br />
                    با استفاده از سامانه “بارپذیر”،‌ صاحبان کالای خارجی که تمایل داشته تا بار خود را به ایران ارسال دارند می‌توانند کامیون‌های فعال نزدیک به مکان‌های مورد نظر خود را مشاهده ‌نمایند.<br />
                    در صورت انتخاب هریک از کامیون‌های موجود بر روی نقشه، اطلاعات ارتباطی "شرکت حمل و نقل" متحرک مورد نظر نمایش داده شده تا در صورت نیاز، صاحب بار بتواند برای ارائه درخواست حمل با آن شرکت تماس حاصل نماید.
                </div>
            </div>
        </div>
     );
}